import { API_UPLOAD_LOGO, imageSharpenStatus, removeWhiteMode, undoRedoType } from '../../../utils/constants';
import {
  autoColorizeForUploadLogo,
  confirmAutoColorize,
  hideCover,
  resizeAndCenterImage,
  startProgressChecking,
} from '../../../uploadimage/components/UploadButton/logics';
import {
  changeCropParameter,
  changeToUnsharpened,
  saveImageOriginColors,
  updateCanvasImage,
} from '../../../canvas/actions';
import { configuratorAction, studioItemType as studioItemTypeEnum } from '../../../main/constants';
import { consoleLog, switchToUnsharpened } from '../../../canvas/logics';
import { hideWaitingCover, showMessageBox, showWaitingCover, updateTempBackgroundImage } from '../../../main/actions';

import { changeNextgenUiStatus } from '../../../nextgen/actions';
import { getConfiguratorAction } from '../../../main/logics';
import { imprintOptionType as imprintOptionTypeEnum } from '../../../utils/constants';
import { post } from '../../../utils/request';
import { pushToUndoList } from '../../../canvas/components/UndoRedo/logic';
import { resetImageToOriginal } from '../../../nextgen/Upload/logics';
import { v4 as uuidv4 } from 'uuid';

export const resetToOriginal = (resetParams) => {
  const { dispatch, image, studioItemType } = resetParams;
  const newImageData = Object.assign({}, image.data);

  // replace pngFileNameList/cloudResourceIdList with original values
  delete newImageData.pngFileNameList;
  newImageData.pngFileNameList = [];
  Object.assign(newImageData.pngFileNameList, newImageData.pngFileNameListOfNoColorize);
  delete newImageData.cloudResourceIdList;
  newImageData.cloudResourceIdList = [];
  Object.assign(newImageData.cloudResourceIdList, newImageData.cloudResourceIdListOfNoColorize);

  // re-assign other lists to make sure writable
  delete newImageData.autoCropRect;
  newImageData.autoCropRect = {};
  Object.assign(newImageData.autoCropRect, image.data.autoCropRect);
  delete newImageData.cropRect;
  newImageData.cropRect = {};
  Object.assign(newImageData.cropRect, image.data.cropRect);
  delete newImageData.finalCropRect;
  newImageData.finalCropRect = {};
  Object.assign(newImageData.finalCropRect, image.data.finalCropRect);
  newImageData.width = image.data.finalCropRect.width;
  newImageData.height = image.data.finalCropRect.height;

  if (studioItemType === studioItemTypeEnum.digital || studioItemType === studioItemTypeEnum.screenPrintedDigital) {
    if (newImageData.sharpenStatus === imageSharpenStatus.Sharpened) {
      newImageData.sharpenStatus = imageSharpenStatus.Unsharpened;
      switchToUnsharpened(newImageData);
    }
  }

  switchToNewRemoveWhiteOption(newImageData, removeWhiteMode.None, studioItemType);
  dispatch(changeCropParameter(null));

  const update = (updatedImageData) => {
    resetImageToOriginal(updatedImageData);

    const colorizeParams = {
      ...resetParams,
      itemUseScene7Template: true,
      isNextgenUi: true,
    };

    dispatch(showWaitingCover({ showProgress: false }));

    if (studioItemType === studioItemTypeEnum.screenPrintedDigital) {
      dispatch(changeNextgenUiStatus({ isReseting: true }));
      dispatch(
        updateCanvasImage({
          canvasKey: resetParams.canvasKey,
          imageId: image.ui.guid,
          newImageData: updatedImageData,
        })
      );

      autoColorizeForUploadLogo({
        colorizeParams,
        updatedImageData,
        guid: image.ui.guid,
        callbackAfterColorize: (colorizedImageData) => {
          dispatch(changeNextgenUiStatus({ isReseting: false }));
          dispatch(saveImageOriginColors({ canvasKey: resetParams.canvasKey, imageId: image.ui.guid }));
          confirmAutoColorize(dispatch, colorizeParams, colorizedImageData, image.ui.guid);
        },
      });
    } else {
      dispatch(
        updateCanvasImage({
          canvasKey: resetParams.canvasKey,
          imageId: image.ui.guid,
          newImageData: updatedImageData,
        })
      );
      resizeAndCenterImage(dispatch, updatedImageData, image.ui.guid, resetParams);
      hideCover(dispatch);
    }
  };

  if (
    newImageData.pngFileNameListOfNoColorize[removeWhiteMode.None] &&
    newImageData.cloudResourceIdListOfNoColorize[removeWhiteMode.None]
  ) {
    update(newImageData);
  } else {
    applyResetToOriginal({ ...resetParams, callback: update });
  }
};

export const changeRemoveWhite = (removeWhiteParams) => {
  const {
    dispatch,
    canvasKey,
    image,
    newOption,
    isHotStamped,
    studioItemType,
    isBackground,
    draggingArea,
    imprintColorList,
    currentImprintFormat,
    imprintOptionType,
    isNextgenUi,
    isMultipleArtMultipleColor,
    allColorsInUse,
    actionStatus,
  } = removeWhiteParams;

  let newImageData = Object.assign({}, image.data);
  newImageData.removeWhiteOption = newOption;

  if (newImageData.cloudResourceIdListOfNoColorize && newImageData.cloudResourceIdListOfNoColorize[newOption]) {
    switchToNewRemoveWhiteOption(newImageData, newOption, studioItemType, actionStatus);

    if (isBackground) {
      dispatch(updateTempBackgroundImage(newImageData));
    } else {
      dispatch(
        updateCanvasImage({
          canvasKey,
          imageId: image.ui.guid,
          newImageData: newImageData,
          draggingArea,
          isHotStamped,
        })
      );

      //unsharpen for new removewhite option
      if (studioItemType === studioItemTypeEnum.digital) {
        if (image.data.sharpenStatus === imageSharpenStatus.Sharpened) {
          dispatch(changeToUnsharpened({ canvasKey, imageId: image.ui.guid }));
          dispatch(pushToUndoList(undoRedoType.ChangeTemplateOrEditElement));
        }
      } else {
        if (isNextgenUi && (!image.ui.isColorized || !image.ui.isColorized[newOption])) {
          // do colorize for screen-printed item in nextgen ui
          const selectedLogo = { data: newImageData, ui: { guid: image.ui.guid } };

          var isSingleColorItem = currentImprintFormat.maxColorCount === 1 ? true : false;
          var isTextLogo = imprintOptionType === imprintOptionTypeEnum.TextLogo;
          let newImprintColorList = isSingleColorItem && isTextLogo ? selectedLogo.data.colors : imprintColorList;

          if (studioItemType === studioItemTypeEnum.screenPrintedDigital) {
            newImprintColorList = Object.assign([], newImprintColorList);
            newImprintColorList = newImprintColorList.filter(
              (color) => !allColorsInUse.find((c) => c.colorId == color.colorId)
            );
            newImprintColorList = allColorsInUse.concat(newImprintColorList);
          }

          const colorizeParams = {
            ...removeWhiteParams,
            imprintColorList: newImprintColorList,
            selectedLogo,
            maxColorCount: currentImprintFormat.maxColorCount,
            itemUseScene7Template: true,
            guid: image.ui.guid,
          };

          dispatch(changeNextgenUiStatus({ showCanvasCover: true }));
          dispatch(changeNextgenUiStatus({ isRemovingWhite: true }));

          autoColorizeForUploadLogo({
            colorizeParams,
            updatedImageData: selectedLogo.data,
            guid: selectedLogo.ui.guid,
            callbackAfterColorize: (colorizedImageData) => {
              dispatch(changeNextgenUiStatus({ isRemovingWhite: false }));
              dispatch(saveImageOriginColors({ canvasKey, imageId: selectedLogo.ui.guid }));
              confirmAutoColorize(dispatch, colorizeParams, colorizedImageData, selectedLogo.ui.guid);
            },
          });
        }
      }
    }
  } else if (isBackground && newOption === removeWhiteMode.None) {
    // bug fix: if background and option=None, not really call backend
    newImageData.pngFileName = newImageData.pngFileNameOfNoRemoveWhite;
    newImageData.cloudResourceId = newImageData.cloudResourceIdList[newOption];
    newImageData.scene7FileName = newImageData.cloudResourceId;
    newImageData.imagingServiceSessionId = newImageData.imagingServiceSessionIdList[newOption];
    dispatch(updateTempBackgroundImage(newImageData));
  } else applyRemoveWhite(removeWhiteParams);
};

const applyRemoveWhite = (removeWhiteParams) => {
  removeWhiteParams.frontId = uuidv4();
  const { dispatch, vendorId, image, newOption, frontId, itemId, isBackground } = removeWhiteParams;

  post(
    API_UPLOAD_LOGO +
      (isBackground ? '/RemoveWhiteForBackground' : '/RemoveWhite') +
      '?frontId=' +
      frontId +
      '&itemId=' +
      itemId +
      '&vendorId=' +
      vendorId +
      '&option=' +
      newOption,
    image.data
  )
    .then((res) => {
      startProgressChecking(removeWhiteParams);
    })
    .catch((err) => {
      consoleLog(err);
      dispatch(hideWaitingCover());
      dispatch(showMessageBox(err.message));
    });

  dispatch(showWaitingCover({ showProgress: true }));
};

const applyResetToOriginal = (resetParams) => {
  resetParams.frontId = uuidv4();
  const { dispatch, vendorId, studioItemType, image, frontId, isHotStamped } = resetParams;

  post(
    API_UPLOAD_LOGO +
      '/' +
      (resetParams.isNonDigital ? 'ResetToOriginalNonDigital' : 'ResetToOriginal') +
      '?frontId=' +
      frontId +
      '&vendorId=' +
      vendorId,
    image.data
  )
    .then((res) => {
      if (resetParams.isNonDigital) {
        dispatch(
          updateCanvasImage({
            canvasKey: resetParams.canvasKey,
            imageId: image.ui.guid,
            newImageData: res.data,
            resetToOriginal: true,
            draggingArea: resetParams.draggingArea,
            isHotStamped,
          })
        );

        dispatch(hideWaitingCover());
      } else {
        resetParams.newOption = removeWhiteMode.None;
        startProgressChecking(resetParams);
      }
    })
    .catch((err) => {
      consoleLog(err);
      dispatch(hideWaitingCover());
      dispatch(showMessageBox(err.message));
    });

  dispatch(showWaitingCover({ showProgress: studioItemType !== studioItemTypeEnum.digital ? false : true }));
};

const switchToNewRemoveWhiteOption = (newImageData, newRemoveWhiteOption, studioItemType, actionStatus) => {
  newImageData.pngFileName = newImageData.pngFileNameListOfNoColorize[newRemoveWhiteOption];
  newImageData.cloudResourceId = newImageData.cloudResourceIdListOfNoColorize[newRemoveWhiteOption];
  newImageData.scene7FileName = newImageData.cloudResourceId;

  // must update derived properties because the backend auto-mapper may set the data back to list
  newImageData.imagingServiceSessionId = newImageData.imagingServiceSessionIdList[newRemoveWhiteOption];
  newImageData.pngFileNameOfNoColorize = newImageData.pngFileNameListOfNoColorize[newRemoveWhiteOption];
  newImageData.cloudResourceIdOfNoColorize = newImageData.cloudResourceIdListOfNoColorize[newRemoveWhiteOption];

  // pngFileNameListOfNoColorize contains original images without colorize and no sharpen
  // screenPrinted will auto do colorize and sharpen, so should reset original size here
  if (studioItemType === studioItemTypeEnum.screenPrintedDigital && newImageData.sharpenSizeRate > 0) {
    console.warn('switchToNewRemoveWhiteOption - newImageData:', newImageData);

    newImageData.originalWidth = Math.round(newImageData.originalWidth / newImageData.sharpenSizeRate);
    newImageData.originalHeight = Math.round(newImageData.originalHeight / newImageData.sharpenSizeRate);
    if (newImageData.autoCropRect && newImageData.cropRect && newImageData.finalCropRect) {
      newImageData.autoCropRect = {
        ...newImageData.autoCropRect,
        width: Math.round(newImageData.autoCropRect.width / newImageData.sharpenSizeRate),
        height: Math.round(newImageData.autoCropRect.height / newImageData.sharpenSizeRate),
      };

      newImageData.cropRect = {
        ...newImageData.cropRect,
        width: Math.round(newImageData.cropRect.width / newImageData.sharpenSizeRate),
        height: Math.round(newImageData.cropRect.height / newImageData.sharpenSizeRate),
      };

      newImageData.finalCropRect = {
        ...newImageData.finalCropRect,
        width: Math.round(newImageData.finalCropRect.width / newImageData.sharpenSizeRate),
        height: Math.round(newImageData.finalCropRect.height / newImageData.sharpenSizeRate),
      };
    }
    newImageData.sharpenStatus = imageSharpenStatus.Unsharpened;
    newImageData.sharpenSizeRate = 1;
  }
};
